import { Injectable } from '@jack-henry/frontend-utils/di';
import { exists } from '@jack-henry/frontend-utils/functions';
import { TmSideDrawerService } from '@treasury/presentation/services/side-drawer';
import { html } from 'lit';
import { RowActionCommand, RowActionCommandResult } from '../../users/base.cmd';
import { CompanyActionType } from '../company-action.types';
import { UserSettingsDrawer } from './overlays/user-settings-drawer/user-settings.component';

@Injectable()
export class UserSettingsCommand implements RowActionCommand<number, CompanyActionType> {
    constructor(private readonly sideDrawerService: TmSideDrawerService) {}

    public command(): RowActionCommandResult<number, CompanyActionType> {
        return {
            type: CompanyActionType.UserSettings,
            title: 'Company User Settings',
            hiddenCondition: false,
            action: (companyId: number) => this.execute(companyId),
        };
    }

    private execute(companyId: number) {
        if (!exists(companyId)) {
            return;
        }

        this.sideDrawerService.open(
            html`<tm-bo-user-settings
                .companyId=${companyId}
                @close=${() => {
                    this.sideDrawerService.close();
                }}
                @confirm=${async () => {
                    if (!companyId) {
                        throw new Error('Failed to save company users settings');
                    }
                    this.sideDrawerService.close();
                }}
            ></tm-bo-user-settings>`,
            UserSettingsDrawer.title
        );
    }
}
